import React from 'react';
import { Link } from '../root/components/Link';
import { useRecoilValue } from 'recoil';
import { CardTitle } from '../components/CardTitle';
import { WistiaPanel } from '../components/WistiaPanel';
import { isMobileState } from '../recoil/selectors';
import { assetPathFn } from '../util';
import styles from './WhyHoneylove.module.scss';

type FeatureSectionKeys = 'fit' | 'quality' | 'size' | 'return';

export const WhyHoneylove: React.FC<{ hideSections?: FeatureSectionKeys[] }> = ({ hideSections }) => {
  const isMobile = useRecoilValue(isMobileState);

  const titleStyles = isMobile ? { padding: '15px 0px', width: 'unset' } : { padding: '30px 0' };
  const wistiaVideoId = isMobile ? 'cjxwg1a593' : '1t2wafl6se';
  const wistiaPadding = isMobile ? '145.0% 0 0 0' : '56.25% 0 0 0';

  return (
    <div className={styles.whyHoneyloveCard}>
      <WistiaPanel videoId={wistiaVideoId} responsivePadding={{ padding: wistiaPadding }} />
      <div className={styles.featureWrapper}>
        {!hideSections?.includes('return') && (
          <div>
            <img src={assetPathFn('30-day-icon.png')} style={{ width: 80, marginTop: 25, marginBottom: -10 }} alt="30 day returns" />
            <Link dataTrackLabel="easy returns" dataTrackLocation="why-honeylove" href="/pages/returns">
              <CardTitle text="Easy returns" style={titleStyles} />
            </Link>
            <div>Enjoy free US shipping and a 30-day hassle-free return policy. Our customer service is here to help.</div>
          </div>
        )}
        {!hideSections?.includes('quality') && (
          <div>
            <img src={assetPathFn('quality-star.png')} style={{ width: 38, marginTop: 35 }} alt="quality" />
            <Link dataTrackLabel="quality" dataTrackLocation="why-honeylove" href="/pages/about-us">
              <CardTitle text="Quality" style={titleStyles} />
            </Link>

            <div>We take the time to source the softest, most durable, performance fabrics that you’ll feel great wearing.</div>
          </div>
        )}
        {!hideSections?.includes('size') && (
          <div>
            <img src={assetPathFn('size-inclusive-icon.png')} style={{ width: 90, marginTop: 35 }} alt="size inclusive" />
            <Link dataTrackLabel="size inclusive" dataTrackLocation="why-honeylove" href="/pages/about-us">
              <CardTitle text="Size inclusive" style={titleStyles} />
            </Link>

            <div>We strive to serve as many body shapes and sizes as possible so everyone can find their perfect fit.</div>
          </div>
        )}
        {!hideSections?.includes('fit') && (
          <div>
            <img src={assetPathFn('fit-obsessed.png')} style={{ width: 49, marginTop: 12 }} alt="fit obsessed" />
            <Link dataTrackLabel="fit obsessed" dataTrackLocation="why-honeylove" href="/pages/about-us">
              <CardTitle text="Fit Obsessed" style={titleStyles} />
            </Link>
            <div>Each item goes through +2 years of rigorous testing with real women who want more from their clothing.</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default WhyHoneylove;
